import React from 'react'

import { Link } from 'react-router-dom'
import MechanicsBlock from '../../components/Mechanics'

const InstantPagesSection = ({ activeType, currentImages, is_auth, t }) => (
    <div className="instant-page-section">
        <h3>{t(activeType.texts.additional.header)}</h3>
        <div className="instant-page-section__container">
            <div className="instant-page-section__blank">
                <div className="instant-page-section__blank-title">{t('Your article')}</div>
                <article>
                    {t(activeType.texts.additional.articles[0])}
                    <div className="instant-page-section__blank-hint blank-hint-1">
                        <img src={currentImages.additional.arrow2} alt="arrow" />
                        <p>{t(activeType.texts.additional.hints[0])}</p>
                    </div>
                </article>
                <ul className="instant-page-section__blank-buttons">
                    <li>
                        <img src={currentImages.additional.addText} alt="addText" />
                        Add text
                    </li>
                    <li>
                        <img src={currentImages.additional.addImage} alt="addImage" />
                        Add image
                    </li>
                    <li>
                        <img src={currentImages.additional.addFlip} alt="addFlip" />
                        Add Flip
                    </li>
                    <li>
                        <img src={currentImages.additional.embedProject} alt="embedProject" />
                        Embed Interacty project
                    </li>
                </ul>
                <div className="instant-page-section__blank-workplace">
                    <ul className="instant-page-section__blank-workplace-tools">
                        <li>
                            <img src={currentImages.additional.up} alt="up" />
                        </li>
                        <li>
                            <img src={currentImages.additional.up} alt="down" className="move-img-reverse" />
                        </li>
                        <li>
                            <img src={currentImages.additional.copy} alt="copy" />
                        </li>
                        <li>
                            <img src={currentImages.additional.delete} alt="delete" />
                        </li>
                    </ul>
                    <div className="instant-page-section__blank-workplace-cursor">
                        <img src={currentImages.additional.cursor} alt="cursor" />
                    </div>
                    <div className="instant-page-section__blank-workplace-image workplace-image-1">
                        <img src={currentImages.additional.image1} alt="cursor" />
                        <div className="instant-page-section__blank-hint blank-hint-2">
                            <img
                                className="instant-page-section__blank-hint-img-desktop"
                                src={currentImages.additional.arrow3}
                                alt="arrow"
                            />
                            <img
                                className="instant-page-section__blank-hint-img-mobile"
                                src={currentImages.additional.arrow3m}
                                alt="arrow"
                            />
                            <p>{t(activeType.texts.additional.hints[1])}</p>
                        </div>
                    </div>
                    <div className="instant-page-section__blank-workplace-image workplace-image-2">
                        <img src={currentImages.additional.image2} alt="cursor" />
                        <div className="instant-page-section__blank-hint blank-hint-3">
                            <img
                                className="instant-page-section__blank-hint-img-desktop"
                                src={currentImages.additional.arrow4}
                                alt="arrow"
                            />
                            <img
                                className="instant-page-section__blank-hint-img-mobile"
                                src={currentImages.additional.arrow4m}
                                alt="arrow"
                            />
                            <p>{t(activeType.texts.additional.hints[2])}</p>
                        </div>
                    </div>
                </div>
                <article>{t(activeType.texts.additional.articles[1])}</article>
                <div className="instant-page-section__blank-add-content">
                    <img src={currentImages.additional.add} alt="add" />
                    <h5>{t(activeType.texts.additional.addInteractiveContent)}</h5>
                </div>
            </div>
            <div className="instant-page-section__container-mechanics-blanked">
                <MechanicsBlock
                    additionalClass="__landing-instant-pages"
                    bgColor={activeType.colors.mechanic_bg}
                    fontColor={activeType.colors.mechanic_font}
                    title={false}
                    subtitle={false}
                    showStory={false}
                />
            </div>
            <div className="instant-page-section__container-arrow-head">
                <img src={currentImages.additional.arrow1} alt="arrow1" />
                <h5>{t(activeType.texts.additional.embedAnywhere)}</h5>
            </div>
            <div className="instant-page-section__embed_project">
                <p>{'<div class="remix-app" hash="d209acae-3679-429e-8c48-d5287b6ef4b">'}</p>
                <p>{'<script src="https://p.interacty.me" async></script></div>'}</p>
            </div>
            <div className="instant-page-section__buttons">
                <Link to={`/template-gallery`} className="button-style" data-size="lg" data-variant="primary-light">
                    {t(`view templates`)}
                </Link>
                <Link
                    to={`${is_auth ? '/template-gallery' : '/auth?action=registration'}`}
                    className="button-style"
                    data-size="lg"
                    data-variant="primary"
                >
                    {t(`create for free`)}
                </Link>
            </div>
        </div>
        <div className="instant-page-section__editor">
            <img src={currentImages.additional.editor} alt="editor" />
        </div>
    </div>
)

export default InstantPagesSection
